module.exports = __webpack_public_path__ + "static/img/person.b7897ad3.webp";